<template>
    <div class="big_box">
        <div class="img_89 title_center"></div>
        <div class="content_center">
            <table class="table">
                <thead>
                <tr>
                    <th style="width: 50%">抽奖结果</th>
                    <th style="width: 50%">抽奖时间</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item,key in list">
                    <td>{{ item.name || item.item_id}}</td>
                    <td>{{ item.create_at }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
module.exports = {
    data() {
        return {
            list: [],
        }
    },
    created() {

        this.get_data()
    },
    methods: {
        get_data() {
            var that = this
            this.$httpr.select_lottery_list(function (err, result) {
                err = err || result.err || result.msg
                if (err) {
                    return that.$alter('err', err)
                }
                result.data.forEach(i=>i.name=that.conf_name[i.item_id])
                that.list = result.data
            })
        }
    }
}
</script>

<style scoped>
.head {
    width: 50%;
    color: #424345;
}

table {
    width: 94%;
    margin: auto;
}

tbody {
    color: #ff761c;
}

table,
table td,
table th {
    height: .45rem;
    border: 0.03rem solid #000000;
    text-align: center;
}

.content_center {
    font-size: 0.25rem;
    color: #000000;
    /*font-weight: bold;*/
}
.big_box.big_box.big_box.big_box{
    height: 93%;
}
</style>